export default "__VITE_ASSET__DGNUc0s6__"